import {TeamModel} from '../../../../libs/shared/core/src/models/api/teamModel';
import {TrackDataEvent} from '../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {AppStore} from '../../../store/appStore';
import {SetupGuideEnum} from '../../../store/stateless/onboardingSelectors';
import {OnboardingModalContextProps} from '../../app/topBar/onboarding/onboardingContext';

export interface OnboardingGatingProps {
  setupGuide: SetupGuideEnum | undefined;
  isUserFirstGlobalAdmin: boolean;
  isInManagedTrial: boolean;
  wasOnboardingCompleted: boolean;
}

export interface OnboardingFlowProps {
  gating: OnboardingGatingProps;
}

export interface OnboardingFlowStepProps {
  dispatch: AppStore['dispatch'];
  gating: OnboardingGatingProps;
  onboardingModalContext: OnboardingModalContextProps;
  trackDataEvent: TrackDataEvent;
  onEndOnboardingFlow: () => void;
  sandboxTeam: TeamModel | undefined;
}

export enum OnboardingFlowStepNameEnum {
  DESKTOP_RECOMMENDATION = 'desktop_recommendation',
  ONBOARDING_QUESTIONNAIRE_ADMIN_WIZARD = 'onboarding_questionnaire_admin_wizard',
  ONBOARDING_QUESTIONNAIRE = 'onboarding_questionnaire',
  ADMIN_WIZARD = 'admin_wizard',
  SANDBOX_DEMO = 'sandbox_demo',
  SETUP_GUIDE = 'setup_guide',
  FLU_GUIDE = 'flu_guide',
}

export enum OnboardingFlowNameEnum {
  ONBOARDING_QUESTIONNAIRE_FIRST_ADMIN = 'onboarding_questionnaire_first_admin',
  DEFAULT = 'default',
}

export enum OnboardingFlowTransitionEnum {
  DESKTOP_RECOMMENDATION_COMPLETE = 'desktop_recommendation_complete',
  START_ONBOARDING = 'start_onboarding',
  ONBOARDING_QUESTIONNAIRE_COMPLETE = 'onboarding_questionnaire_complete',
  ONBOARDING_QUESTIONNAIRE_CANCEL = 'onboarding_questionnaire_cancel',
  ADMIN_WIZARD_COMPLETE = 'admin_wizard_complete',
  ADMIN_WIZARD_CANCEL = 'admin_wizard_cancel',
  SANDBOX_DEMO_COMPLETE = 'sandbox_demo_complete',
  FLU_GUIDE_COMPLETE = 'flu_guide_complete',
}

export interface OnboardingFlowStep {
  onStart: (props: OnboardingFlowStepProps) => Promise<void>;
  onEnd?: (props: OnboardingFlowStepProps) => Promise<void>;
}

export interface OnboardingFlow {
  // Is this flow applicable to the user/role in question?
  // The return value for this method should be pretty stable, for instance completing the flow
  // shouldn't make it inapplicable (use shouldStart for that).
  isApplicable: (props: OnboardingFlowProps) => Promise<boolean>;

  // Should we automatically start the initial steps of the onboarding flow?
  shouldStart: (props: OnboardingFlowProps) => Promise<boolean>;

  // Maps cues in the app to the relevant next step in the onboarding flow.
  transitions: {
    [transition: string]: (props: OnboardingFlowStepProps) => Promise<OnboardingFlowStepNameEnum | undefined>;
  };
}
